import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
const ComponentLoading = ({ loadingText }) => (_jsx("div", Object.assign({ className: 'w-full z-50 h-full absolute top-0 left-0 bg-black-modal flex items-center justify-center' }, { children: _jsxs("h3", Object.assign({ className: 'text-white text-2xl' }, { children: [loadingText, ".."] })) })));
ComponentLoading.propTypes = { loadingText: PropTypes.string.isRequired };
export default ComponentLoading;
